
export const network = {
  partnerNetwork: {
    title: "Partner Network",
    connect: "Connect Partner",
    myCode: "Your Clinic Code",
    copy: "Copy Code",
    status: "Connection Status",
    pending: "Pending Approval",
    active: "Connected",
    rejected: "Rejected",
    providerMode: "Provider Mode (Clinic)",
    clientMode: "Client Mode (Dispensary)",
    connectTitle: "Connect to a Clinic",
    connectDesc: "Enter the Clinic Code provided by your partner to start sending patients.",
    partnerCode: "Partner Code (Store ID)",
    connectBtn: "Connect",
    subtitle: "Connect your system with external Clinics or Dispensaries for patient referrals.",
    incomingReq: "Incoming Request",
    outgoingReq: "Outgoing Request",
    accept: "Accept",
    reject: "Reject",
    empty: "No connections yet.",
    emptyClient: "No clinics connected.",
    noteTitle: "Note",
    noteDesc: "Once connected, you can select this clinic to refer patients to during registration.",
    cannotSelf: "Cannot connect to your own store ID."
  },
  loyaltyManagement: {
    title: "Loyalty & Promotions",
    loading: "Loading...",
    addNewReward: "Add Reward",
    addNewTier: "Add Tier",
    deleteConfirm: "Are you sure you want to delete {{item}}?",
    tabs: {
      rewards: "Rewards",
      tiers: "Tiers"
    },
    rewardsTable: {
      name: "Reward Name",
      sku: "SKU",
      points: "Points Cost",
      cost: "Est. Cost",
      status: "Status"
    },
    tiersTable: {
      icon: "Icon",
      name: "Tier Name",
      minPoints: "Min Points",
      benefits: "Benefits"
    }
  }
};
